import http from '../services/httpClient';

/**
 * Continuous Closing Stock — undoing an entry (spec §9.5).
 *
 * For a switched-on business the server refuses an undo without a reason
 * (400 REASON_REQUIRED). This asks for one and sends it; every register row the undo
 * records carries it. A business that is not switched on never asks — the first call
 * simply succeeds. A refusal for lack of authority (403 NEEDS_MANAGER) comes back as the
 * usual { success:false, error } for the caller to show.
 */
export function askUndoReason() {
  const reason = window.prompt('Why is this being undone? (required)');
  return reason && reason.trim().length >= 3 ? reason.trim() : null;
}

export async function postUndo(path, body = {}) {
  try {
    return await http.post(path, body);
  } catch (error) {
    if (error && error.data && error.data.code === 'REASON_REQUIRED' && !body.reason) {
      const reason = askUndoReason();
      if (reason) return http.post(path, { ...body, reason });
      const cancelled = new Error('Undo cancelled — a reason is required.');
      cancelled.cancelled = true;
      throw cancelled;
    }
    throw error;
  }
}

export default postUndo;
